import React, { createContext, useContext } from 'react';
import { AppContextType } from './types';
import { Navbar } from './components/layout/navbar';
import { HeroSection } from './components/sections/heroSection';
import { IndividualSection } from './components/sections/individualSection';
import { BusinessSection } from './components/sections/businessSection';
import { FeaturesSection } from './components/sections/feturesSection';
import { TestimonialsSection } from './components/sections/testimonialsSection';
import { Footer } from './components/layout/Footer';
import { ContactSection } from './components/sections/contactSection';
import { FloatingAssistant } from './components/layout/floatingAssistant';
import { AppProvider } from './components/appProvider';
import HomePage from './pages/homePage';
import { Route, Routes } from 'react-router-dom';
import { ExtensionInstallPage } from './pages/extensionInstallPage';
import { NotFoundPage } from './pages/NotFoundPage';
import BusinessPage from './pages/businessPage';
import FeaturePage from './pages/featuresPage';
import PricingPage from './pages/pricingPage';
import ContactPage from './pages/contactPage';


// Types


// Context pour le thème

const App: React.FC = () => {
  return (
    <AppProvider>
      <Routes>
        <Route path='/' element={<HomePage />} />
        {/* <Route path='/3wchat-extension' element={<ExtensionInstallPage />} /> */}
        <Route path='/individual' element={<ExtensionInstallPage />} />
        <Route path='/business' element={<BusinessPage />} />
        <Route path='/features' element={<FeaturePage />} />
        <Route path='/pricing' element={<PricingPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </AppProvider>
  );
}
export default App;
